import { Fragment, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ArrowUpOnSquareStackIcon } from '@heroicons/react/24/outline';
import { PhoneIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Popup = ({ open, onHide, id, product }) => {
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();
  const [message, setMessage] = useState('Verkäufer kontaktieren');
  const [showButton, setShowButton] = useState(true);

  const handleSendRequest = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`https://dealersonly.parts/beta/api/orders/create`, {
        productID: id,
      });

      setMessage(response.data);
      setShowButton(false);
      setTimeout(() => {
        navigate('/shop/home');
      }, 2000);
    } catch (error) {
      setMessage(error.response.data);
      setShowButton(false);
      setTimeout(onHide, 2000);
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={onHide}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                    <ArrowUpOnSquareStackIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                      {message}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Um den Artikel zu erwerben, kann der Verkäufer folgendermaßen kontaktiert werden.
                      </p>
                      <section aria-labelledby="policies-heading" className="mt-10">
                        <dl className="grid grid-cols-1 gap-6 sm:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1">
                          <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-center">
                            <dt>
                              <PhoneIcon className="mx-auto h-6 w-6 flex-shrink-0 text-gray-400" aria-hidden="true" />
                              <span className="mt-4 text-sm font-medium text-gray-900">Kontakt</span>
                            </dt>
                            <dd className="mt-1 text-sm text-gray-500">
                                <p><span className='font-semibold'>Tel: </span>{product?.contactPreferenceTelefon}</p>
                                <p><span className='font-semibold'>Mail: </span>{product?.contactPreferenceEmail}</p>
                            </dd>
                          </div>
                        </dl>
                      </section>
                    </div>
                  </div>
                </div>
                {showButton && (
                  <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-1 sm:gap-3">
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                      onClick={onHide}
                      ref={cancelButtonRef}
                    >
                      Abbrechen
                    </button>
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Popup;
